import axios from "axios"
import { useGeneral } from "../context/general"
import { aggregationOptions } from '../utils/aggregationUtils'

export default function useAlerts() {
    const {userAlerts, setUserAlerts, setPopupAlert} = useGeneral()

    const createNewAlert = (data, ticker) => {
        const {datasetValue:dataset, columnValue:column, columnName, datasetName} = data.selectedDataset
        delete data['selectedDataset']
        // fetch('/api/createAlert', {
        //     method: 'post',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ ...data, ticker, dataset, column})
        // })
        axios({
            method: 'post',
            url: '/api/createAlert',
            data: { ...data, ticker, dataset, column },
        })
        .then(res => res.data)
        .then(res => {
            if(res) { 
                setUserAlerts(prevState => [{
                    uuid: res.uuid, 
                    dataset, 
                    column, 
                    columnName, 
                    datasetName, 
                    time_period: data.timePeriod,
                    ticker, 
                    ...data
                    }, ...prevState ])
                setPopupAlert('success', 'A new alert has been created successfully')
            }
            else if(res.status === 412) setPopupAlert('error', 'Alert already exists.')
            else setPopupAlert('error', 'Cannot create alert')
        })

    }
    
    const removeAlert = (uuid) => {
        // fetch('/api/removeAlert', {
        //     method: 'post',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ uuid })
        // })
        axios({
            method: 'post',
            url: '/api/removeAlert',
            data: { uuid }
        })
        .then(res => res.data)
        .then(res => {
            if(res) { 
                setUserAlerts(userAlerts.filter(item => item.uuid !== uuid ))
                setPopupAlert('success', 'Alert has been removed successfully')
            }
            else { setPopupAlert('error', 'Cannot remove alert') }
        })
    }

    const editAlert = (newAlert) => {
        // fetch('/api/editAlert', {
        //     method: 'post',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ newAlert })
        // })
        axios({
            method: 'post',
            url: '/api/editAlert',
            data: { newAlert }
        })
        .then(res => res.data)
        .then(res => {
            if(res) { 
                setUserAlerts([{...newAlert}, ...userAlerts.filter(item => item.uuid !== newAlert.uuid)])
                setPopupAlert('success', 'Alert has been updated successfully')
            }
            else { setPopupAlert('error', 'Cannot update alert') }
        })
    }


    const alertTypeFormat = (value) => {
        if (!value.change) return null
        const prefix = value.change > 0 ? 'Above' : 'Below'
        return `${prefix} ${value.change}% ${aggregationOptions.group.find(time => time.value === value.frequency)?.name}`
    }

    return {
        createNewAlert,
        removeAlert,
        editAlert,
        alertTypeFormat
    }
}